import React, { Component } from "react";
import classnames from "classnames";
import styles from "./Components.local.scss";
import { number_format } from "Utils";
import Percentage from "../../Common/Percentage/Percentage";
import ComponentActions from "./ComponentActions";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from "recharts";
import { Modal } from "antd";
import {
  CustomizedYAxisTick,
  CustomTooltip,
  COLORS
} from "../../Common/Charts/Common";

class IllustrativeProgressBarsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      progressBarsWidth: ["0%", "0%", "0%", "0%", "0%", "0%"],
      selectedItems: [],
      hasChildren: false,
      showModal: false,
      label: "",
      years: [],
      chartData: []
    };
  }

  componentDidMount() {
    const { component } = this.props;

    const {
      data: { accounts }
    } = component;

    this.calculateProgressBarsWidth(accounts);
  }

  handleOnClick = data => {
    if (data.children) {
      this.setState({
        hasChildren: true
      });

      const accounts = data.children;
      const categories = Object.keys(accounts);
      const sampleCategory = accounts[categories[0]].value;
      const years = Object.keys(sampleCategory);
      const chartData = categories.map(key => {
        const categoryData = { name: accounts[key].label };
        years.forEach(year => {
          categoryData[year] = accounts[key].value[year].value;
        });
        return categoryData;
      });

      this.setState({
        showModal: true,
        label: data.label,
        years: years,
        chartData: chartData,
        selectedItems: [chartData[0].name]
      });
    }
  };

  handeOnCancel = () => {
    this.setState({
      hasChildren: false,
      showModal: false,
      years: [],
      chartData: []
    });
  };

  handleItemClick = item => {
    this.setState(prevState => {
      const { selectedItems } = prevState;
      return {
        selectedItems: selectedItems.includes(item)
          ? selectedItems.filter(i => i !== item)
          : [...selectedItems, item]
      };
    });
  };

  handleSelectAllToggle = data => {
    const { selectedItems } = this.state;
    const allItems = data.map(item => item.name);

    if (selectedItems.length === allItems.length) {
      this.setState({ selectedItems: [] });
    } else {
      this.setState({ selectedItems: allItems });
    }
  };

  renderBarChartModal = (data, selectedItems, label, showModal, years) => {
    const chartData = years.map(year => ({ year }));

    chartData.forEach(entry => {
      selectedItems.forEach(itemName => {
        const item = data.find(d => d.name === itemName);
        if (item) {
          entry[itemName] = item[entry.year] || 0;
        }
      });
    });

    return (
      <Modal
        title={`Dépenses Clés - ${label}`}
        visible={showModal}
        onCancel={this.handeOnCancel}
        width="90%"
        footer={null}
        bodyStyle={{ maxHeight: "90vh", overflowY: "auto" }}
      >
        <div className={styles.chart_legend}>
          <div
            className={styles.select_all_legend}
            style={{
              border:
                selectedItems.length === data.length ? "2px solid #18a0fb" : "0"
            }}
            onClick={() => this.handleSelectAllToggle(data)}
          >
            Tout
          </div>
          {data.map((item, index) => (
            <div
              key={item}
              onClick={() => this.handleItemClick(item.name)}
              className={styles.legend_name}
              style={{
                backgroundColor: COLORS[index % COLORS.length],
                opacity: selectedItems.includes(item.name) ? 1 : 0.3
              }}
            >
              {selectedItems.includes(item.name) ? (
                <span
                  className={styles.legend_name_active}
                  style={{ backgroundColor: COLORS[index % COLORS.length] }}
                />
              ) : (
                <span />
              )}
              {item.name}
            </div>
          ))}
        </div>
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={chartData}>
            <CartesianGrid
              vertical={false}
              stroke="#6d7f92"
              strokeWidth={0.2}
            />
            <XAxis dataKey="year" axisLine={false} />
            <YAxis
              tick={<CustomizedYAxisTick currency="€" />}
              axisLine={false}
              tickLine={false}
              type={"number"}
            />
            <Tooltip
              cursor={{ fill: "#f3faff", opacity: 0.6 }}
              content={<CustomTooltip />}
            />
            {selectedItems.map(item => {
              const index = data.findIndex(d => d.name === item);
              return (
                <Bar
                  key={item}
                  dataKey={item}
                  fill={COLORS[index % COLORS.length]}
                  maxBarSize={65}
                />
              );
            })}
          </BarChart>
        </ResponsiveContainer>
      </Modal>
    );
  };

  calculateProgressBarsWidth = accounts => {
    setTimeout(() => {
      this.setState({
        progressBarsWidth: accounts.map(
          e =>
            parseFloat(e.progressBarWidth) <= 20 ? "20%" : e.progressBarWidth
        )
      });
    }, 600);
  };

  renderBlocs = (accounts, customBackground) => {
    let blocs = [];
    for (let i = 0; i < accounts.length; i++) {
      blocs.push(
        <div
          key={i}
          className={classnames(
            "medium-12 small-12",
            styles.bloc,
            styles.flex_container
          )}
        >
          <span className={styles.bloc_title}>{accounts[i].label}</span>
          <span
            className={classnames(
              styles.bloc_percentage_span,
              accounts[i].percentage < 0 && accounts[i].percentage >= -5
                ? styles.orange_percentage
                : ""
            )}
          >
            <Percentage percentage={accounts[i].percentage} />
          </span>

          <div
            className={classnames(
              "medium-12 small-12",
              styles.flex_container,
              styles.bloc_progressBar
            )}
          >
            <span
              className={classnames(
                styles.current_filled_value,
                accounts[i].percentage < -5
                  ? styles.danger_bar
                  : accounts[i].percentage < 0
                    ? styles.warning_bar
                    : styles.default_bar
              )}
              style={{
                width: this.state.progressBarsWidth[i],
                cursor: "pointer"
              }}
              onClick={() => this.handleOnClick(accounts[i])}
            >
              <span>
                &nbsp;&nbsp;{" "}
                {accounts[i].notAvailable
                  ? "N/A"
                  : number_format(accounts[i].currentValue, 2, ",", " ")}{" "}
                {accounts[i].unit !== "none" ? accounts[i].unit : ""}
              </span>
            </span>

            <span className={styles.last_year_value_indicator}>
              {accounts[i].notAvailable
                ? "N/A"
                : number_format(accounts[i].lastYearValue, 2, ",", " ")}{" "}
              {accounts[i].unit !== "none" ? accounts[i].unit : ""}
            </span>

            <span className={styles.last_year}>N-1</span>
          </div>
        </div>
      );
    }
    return blocs;
  };

  render() {
    const {
      component,
      layoutProps: {
        customBackground
        // scaleComponent
      }
      // isResponsive
    } = this.props;

    const {
      data: { accounts }
    } = component;

    const {
      hasChildren,
      showModal,
      label,
      years,
      chartData,
      selectedItems
    } = this.state;

    return (
      <div className={styles.Illustrative_container}>
        <div
          className={classnames(
            styles.IllustrativeProgressBarsComponent,
            styles.absolute_container,
            styles.flex_container
            // isResponsive && scaleComponent ? styles.scale_component : null
          )}
        >
          {!this.props.inSlideView &&
            !this.props.isEmbedded && (
              <ComponentActions
                removeComponent={this.props.handleRemoveComponent}
                updateComponent={this.props.handleUpdateComponent}
                componentCase={this.props.ComponentCase}
                sideBar={"MultiIndicatorComponentConfig"}
                component={"IllustrativeProgressBarsComponent.png"}
              />
            )}
          {this.renderBlocs(accounts, customBackground)}
        </div>
        {hasChildren
          ? this.renderBarChartModal(
              chartData,
              selectedItems,
              label,
              showModal,
              years
            )
          : ""}
      </div>
    );
  }
}

export default IllustrativeProgressBarsComponent;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/IllustrativeProgressBarsComponent.js